import { render, staticRenderFns } from "./IniciarDropdownPGDI.vue?vue&type=template&id=24679704&scoped=true&"
import script from "./IniciarDropdownPGDI.vue?vue&type=script&lang=js&"
export * from "./IniciarDropdownPGDI.vue?vue&type=script&lang=js&"
import style0 from "./IniciarDropdownPGDI.vue?vue&type=style&index=0&id=24679704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24679704",
  null
  
)

export default component.exports